import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/VKO.png'
import _imports_1 from '@/assets/images/vko1.jpg'
import _imports_2 from '@/assets/images/vko2.jpg'
import _imports_3 from '@/assets/images/vko3.jpg'
import _imports_4 from '@/assets/images/vko4.jpg'
import _imports_5 from '@/assets/images/vko5.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Восточно-Казахстанская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Восточно-Казахстанская область – одна из перспективных областей для организации въездного туризма. Иностранным путешественникам будет интересно побывать на берегах озера Алаколь, принять пантовые ванны в местных лечебницах, отправиться к подножию мистической горы Белуха. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Направления Туризма")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Статистика туризма в Казахстане утверждает, что в ВКО путешественники отправляются с самыми различными целями. Семейный отдых обычно организовывают на озере Алаколь с его знаменитыми черными галечными пляжами и целебными свойствами водоема. Оздоровиться можно также в поездке в Катон-Карагайский национальный парк. В нем сосредоточено немало санаториев, домов отдыха, пантолечебниц. Ездят туда и просто с целью полюбоваться природными красотами, посетить исторические и культурные объекты, которых здесь немало. ")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "33629")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "27,6")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "582948")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "29741")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Природный Туризм")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как утверждает статистика туризма в Атырауской области, чаще всего сюда едут с целью полюбоваться красотами природы. Это уникальный в географическом плане регион. Он расположен в Прикаспийской низменности около низовий Волги. Местность очень напоминает просторы на юге России, потому сюда приезжает немало путешественников-россиян. "),
        /*#__PURE__*/_createVNode("p", null, " К Каспийскому морю чаще едут в его восточную часть – местная береговая линия относительно ровная, есть небольшие песчаные косы – это отличное место для пеших прогулок. Также можно отправиться на лодке на прибрежные острова. Северные берега Каспия менее популярны у туристов – они часто заболочены и покрыты зарослями тростника. "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Любители живописного природного рельефа могут посетить меловое плато "),
          /*#__PURE__*/_createVNode("strong", null, "Аккегершин"),
          /*#__PURE__*/_createTextVNode(", возвышенность "),
          /*#__PURE__*/_createVNode("strong", null, "Бесшокы"),
          /*#__PURE__*/_createTextVNode(" с огромными карстовыми пещерами, достигающими 150 метров в поперечнике. Перспективное направление – поездки в "),
          /*#__PURE__*/_createVNode("b", null, "Мунайлы-Мола"),
          /*#__PURE__*/_createTextVNode(" – месторождение натурального асфальта. Туристам нравится фотографироваться на фоне гладких черных шаров добытого материала, потому такую фотосессию вполне можно внести в услуги тура. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Горный Отдых")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Не прогадали те компании, которые выбрали направлением во внутреннем туризме активный отдых в горах, как летом, так и зимой. Статистика показывает, что больше всего путешественников отправляются в горные районы Восточно-Казахстанской области. "),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Условия для развития этой ниши рынка здесь – самые благоприятные. В регионе, кроме отрогов "),
          /*#__PURE__*/_createVNode("b", null, "Алтая"),
          /*#__PURE__*/_createTextVNode(", расположены "),
          /*#__PURE__*/_createVNode("b", null, "Саур-Тарбагатайские горы"),
          /*#__PURE__*/_createTextVNode(" – одни из самых красивых в Центральной Азии, с вершинами, покрытыми вечными ледниками на своей северной стороне. Не менее популярен у туристов "),
          /*#__PURE__*/_createVNode("b", null, "Калбинский горный хребет"),
          /*#__PURE__*/_createTextVNode(". ")
        ]),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Возле городов Усть-Каменогорск и Риддер находится несколько горнолыжных курортов. "),
          /*#__PURE__*/_createVNode("b", null, "«Нуртау»"),
          /*#__PURE__*/_createTextVNode(" и "),
          /*#__PURE__*/_createVNode("b", null, "«Алтайские Альпы»"),
          /*#__PURE__*/_createTextVNode(" – самые известные из них. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Развития Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как развивается туризм в Восточно-Казахстанской области? Так как область граничит с Россией и Китаем, это дает отличные предпосылки для посещений региона иностранными путешественниками. Отличные перспективы имеются и у внутреннего туристского продукта ВКО. Среди основных задач, которые принесут турфирмам успех в этой области – развитие придорожного сервиса, открытие новых мест размещения и благоустройство уже существующих. В первую очередь, это частные мини-отели, гостевые дома. Статистика туризма в Казахстане утверждает, что сейчас по популярности они практически сравнялись с классическими гостиницами. "),
        /*#__PURE__*/_createVNode("p", null, " Отличной идеей будет кооперация баз отдыха – своеобразный «обмен туристами», а также разработка новых интересных туристических маршрутов. ")
      ])
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "regio-swiper" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_5
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}